/**
 * Score → visual bucket (0–100). Red → green only (no teal/cyan so high scores read clearly green).
 * Badge classes use ! so they win over inherited/theme Badge styles when variant="inherit".
 */
const BADGE_BUCKET_CLASSES = [
  "!bg-red-500/15 !border-red-500/45 !text-red-600",
  "!bg-orange-600/15 !border-orange-600/40 !text-orange-600",
  "!bg-orange-500/15 !border-orange-500/40 !text-orange-600",
  "!bg-amber-500/15 !border-amber-500/40 !text-amber-600",
  "!bg-yellow-500/15 !border-yellow-500/40 !text-yellow-600",
  "!bg-lime-500/15 !border-lime-500/40 !text-lime-700",
  "!bg-green-500/15 !border-green-500/45 !text-green-700",
  "!bg-green-600/15 !border-green-600/45 !text-green-700",
  "!bg-green-600/20 !border-green-600/55 !text-green-800",
  "!bg-emerald-600/15 !border-emerald-600/50 !text-emerald-800",
];

const TEXT_BUCKET_CLASSES = [
  "text-red-600",
  "text-orange-600",
  "text-orange-600",
  "text-amber-600",
  "text-yellow-600",
  "text-lime-700",
  "text-green-700",
  "text-green-700",
  "text-green-800",
  "text-emerald-800",
];

function normalizeScore(score) {
  const n = Number(score);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.min(100, n));
}

function bucketIndex(score) {
  const normalized = normalizeScore(score);
  if (normalized >= 100) return 9;
  return Math.max(0, Math.min(9, Math.floor(normalized / 10)));
}

export function getScoreBadgeClass(score) {
  return BADGE_BUCKET_CLASSES[bucketIndex(score)];
}

export function getScoreTextClass(score) {
  return TEXT_BUCKET_CLASSES[bucketIndex(score)];
}
